<template>
  <div class="">
    <div class="flex items-center">
      <div class="flex items-center">
        <input
          :type="type"
          :name="name"
          :id="id"
          :value="value"
          @change="handleChange(value)"
          :checked="value == inputValue"
          class="text-primary transition-all duration-100 ease-out dark:bg-gray-900 cursor-pointer dark:accent-secondary"
          :class="[
            {
              'input-error': errorMessage,
            },
            typeView == 'radio' ? 'form-radio' : 'form-checkbox rounded-sm',
            size ? 'h-7 w-7 md:h-10 md:w-10' : 'h-6 w-6',
            { 'border-danger ring-2 ring-offset-2 ring-danger/30': errorMessage },
          ]"
          :disabled="disabled"
        />
        <label :for="id"></label>
      </div>
      <label
        :for="id"
        class="ml-2 font-normal text-sm dark:text-gray-300 cursor-pointer"
        :class="[{ 'text-lg md:text-2xl font-semibold': size }, { 'text-primary/50': disabled }]"
        ><slot>{{ $t(label || '') }}</slot></label
      >
    </div>
    <template v-if="single">
      <span v-show="errorMessage" class="text-danger dark:text-danger text-xs">
        {{ $t(errorMessage || '') }}
      </span>
    </template>
  </div>
</template>

<script>
import { toRef, computed } from 'vue';
import { useField } from 'vee-validate';

export default {
  props: {
    label: String,
    name: String,
    type: {
      type: String,
      default: 'checkbox',
    },
    id: String,
    placeholder: String,
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
    modelValue: {
      type: [Boolean, String, Number],
      default: true,
    },
    btn: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    single: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    typeView: {
      type: String,
      default: 'radio',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    // const name = toRef(props, "name");

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    // console.log('name :>> ', name.value);
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
      checked,
    } = useField(toRef(props, 'name'), undefined, {
      type: 'radio',
      checkedValue: toRef(props, 'value'),
      uncheckedValue: false,
      syncVModel: true,
    });

    const onChange = ({ target }) => {};

    return {
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
      onChange,
      checked,
    };
  },
};
</script>
